import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

import Colours from '/shared/styled/Colours';

export default function destructiveStyle({ $destructive }: ButtonStyleProps) {
  if ($destructive) {
    return css`
      background: ${Colours.red};
      color: ${Colours.white} !important;

      &:hover,
      &:focus,
      &:active {
        background: ${Colours.redDark1};
        color: ${Colours.white} !important;
      }
    `;
  }
}
